import React, { memo, useContext } from 'react';
import { Segment, Table, TableProps } from 'tea-component';
import { SortBy } from "tea-component/table/addons";
import { getColumns } from './utils/common';
import Loading from '@gp/components/Loading';
import NoData from "@gp/components/NoData";
import useTableList from './hooks/useTableList';
import { context as Context } from '@gp/components/Context';
import './index.scss';

const { autotip, scrollable, sortable } = Table.addons;

const LOADING = false;

interface MergeableTableProps {
  sorts: SortBy,
  onSortsChange: (sorts: SortBy) => void,
  [keyName: string]: any,
}

function MergeableTable(props: MergeableTableProps) {
  const {
    sorts,
    onSortsChange,
  } = props;

  const {
    loading,
    dataList: data,
    filter,
    onChange,
  }: HeadcountsContextTypes = useContext(Context) || {};

  const { records, colList } = useTableList({ sourceData: data, type: filter?.type });

  // 表格使用到的插件
  const addons = [
    sortable({
      columns: colList || [],
      value: sorts ? [sorts] : [],
      onChange: (value) => {
        onSortsChange?.(value?.[0] || {});
      },
    }),
    scrollable({
      // maxHeight: 238,
    }),
    autotip({
      isLoading: LOADING,
      hideIcon: !LOADING,  //loading状态显示图标，其他情况不显示
      emptyText: (
        <span style={{color: '#444'}}>
          No data yet.
        </span>
      ),
      style:{
        height: 172,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
        margin: '0 auto',
      },
    }),
  ];

  return (
    <section className="dbg-studio-overall-details-people-headcounts-table-content">
      <Segment
        className="dbg-studio-overall-details-people-fun-pro-segment"
        value={filter?.type}
        options={[
          {text: 'Function', value: '1', disabled: loading && filter?.type !== '1'},
          {text: 'Projects', value: '2', disabled: loading && filter?.type !== '2'},
        ]}
        onChange={onChange}
      />
      {loading ? (<Loading loading style={{height: 260, marginTop: 20}} />) :
      (!data || !data?.dataList?.length)
        ? (<NoData height={200} constomStyle={{fontSize: 14}} />)
        : (
            <Table
              className="dbg-common-table people-headcounts-table-list-table"
              verticalTop
              // bordered="all"
              records={records}
              recordKey="uniqueId"
              columns={getColumns(
                colList,
                filter?.type,
                true,
                data,
              ) as TableProps['columns']}
              addons={addons}
            />
          )
      }
    </section>
  )
}

MergeableTable.defaultProps = {
  sorts: {
    by: '',
    order: undefined,
  },
  onSortsChange: null,
}

export default memo(MergeableTable);
